import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02a3a56e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "study-material-list"
};
const _hoisted_2 = {
  class: "cover-wrapper"
};
const _hoisted_3 = ["src", "onLoad"];
const _hoisted_4 = {
  key: 0,
  class: "price-badge free"
};
const _hoisted_5 = {
  key: 1,
  class: "price-badge paid"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "currency"
}, "¥", -1));
const _hoisted_7 = {
  class: "amount"
};
const _hoisted_8 = {
  class: "material-title"
};
const _hoisted_9 = {
  class: "material-desc"
};
const _hoisted_10 = {
  class: "material-stats"
};
const _hoisted_11 = {
  class: "stat-item"
};
const _hoisted_12 = {
  class: "stat-item"
};
const _hoisted_13 = {
  class: "card-action"
};
const _hoisted_14 = {
  class: "empty-wrapper"
};
import { ref } from "vue";
import { useRouter } from "vue-router";
import { EyeOutlined, ShoppingCartOutlined, ShoppingOutlined } from '@ant-design/icons-vue';
// 本地默认封面（项目内置），保证无网络/无封面字段时也能正常显示
import defaultCoverImage from '@/assets/default-project-image.png';
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialList',
  props: {
    materialList: {
      default: () => []
    }
  },
  setup(__props) {
    const router = useRouter();
    // 记录每个图片是否已加载完成，用于控制淡入，避免「先占位图再真实图」的闪烁
    const imageLoadedMap = ref({});
    const markLoaded = id => {
      if (id == null) return;
      imageLoadedMap.value = {
        ...imageLoadedMap.value,
        [id]: true
      };
    };
    const getImageUrl = item => {
      // 优先用接口返回的封面；当字段为空或加载失败时，统一使用本地默认图兜底
      return !item.coverImage || item.coverImage === '' ? defaultCoverImage : item.coverImage;
    };
    // 当远程图片加载失败（404 / 网络异常）时，强制切换为本地默认图
    const onImgError = e => {
      const img = e.target;
      if (img && img.src !== defaultCoverImage) {
        img.src = defaultCoverImage;
      }
    };
    const formatCount = count => {
      if (!count) return '0';
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + '万';
      }
      return count.toString();
    };
    const props = __props;
    const clickCard = id => {
      router.push(`/business/studyMaterial/detail/${id}`);
    };
    return (_ctx, _cache) => {
      const _component_a_card_meta = _resolveComponent("a-card-meta");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_card = _resolveComponent("a-card");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_list, {
        grid: {
          gutter: 24,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
          xl: 4,
          xxl: 4
        },
        "item-layout": "horizontal",
        "data-source": props.materialList
      }, {
        renderItem: _withCtx(({
          item
        }) => [_createVNode(_component_a_list_item, {
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
            "padding": "10px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_card, {
            hoverable: "",
            onClick: $event => clickCard(item.id),
            class: "material-card"
          }, {
            cover: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              alt: "学习资料",
              src: getImageUrl(item),
              class: _normalizeClass(["cover-image", {
                'is-loaded': imageLoadedMap.value[item.id]
              }]),
              onLoad: $event => markLoaded(item.id),
              onError: _cache[0] || (_cache[0] = $event => onImgError($event))
            }, null, 42, _hoisted_3), Number(item.price) === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 免费 ")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(item.price), 1)]))])]),
            default: _withCtx(() => [_createVNode(_component_a_card_meta, {
              class: "material-meta"
            }, {
              title: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)]),
              description: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(item.description || '暂无简介'), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, [_createVNode(_unref(EyeOutlined)), _createTextVNode(" " + _toDisplayString(formatCount(item.viewCount)), 1)]), _createElementVNode("span", _hoisted_12, [_createVNode(_unref(ShoppingCartOutlined)), _createTextVNode(" " + _toDisplayString(formatCount(item.buyCount)), 1)])])]),
              _: 2
            }, 1024), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
              type: "primary",
              block: "",
              onClick: _withModifiers($event => clickCard(item.id), ["stop"])
            }, {
              icon: _withCtx(() => [_createVNode(_unref(ShoppingOutlined))]),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(Number(item.price) === 0 ? '立即获取' : '立即购买'), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)]),
        empty: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_empty, {
          description: "暂无学习资料"
        })])]),
        _: 1
      }, 8, ["data-source"])]);
    };
  }
});